import React, { useMemo, useState } from "react";
import Breadcrumbs from "../../core/breadcrumbs";
import { Link, Navigate } from "react-router-dom";
import { Filter, Sliders, User, Globe } from "react-feather";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import Select from "react-select";
import { useSelector } from "react-redux";
// import Table from "../../core/pagination/datatable";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
import SupplierModal from "../../core/modals/peoples/supplierModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PlusCircle,RotateCcw
} from "feather-icons-react/build/IconComponents";
import { all_routes } from "../../Router/all_routes";
import CommonMatrialReactTable from "../common/CommonMatrialReactTable.jsx";
import MenuItem from '@mui/material/MenuItem';


const Client = () => {
  const route = all_routes;
  const data = useSelector((state) => state.ClientData);

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const options = [
    { value: "sortByDate", label: "Sort by Date" },
    { value: "140923", label: "14 09 23" },
    { value: "110923", label: "11 09 23" },
  ];
  const optionsTwo = [
    { label: "Choose Customer Name", value: "" },
    { label: "Benjamin", value: "Benjamin" },
    { label: "Ellen", value: "Ellen" },
    { label: "Freda", value: "Freda" },
    { label: "Kaitlin", value: "Kaitlin" },
  ];

  const countries = [
    { label: "Choose Country", value: "" },
    { label: "India", value: "India" },
    { label: "USA", value: "USA" },
  ];

  // const columns = [
  //   {
  //     title: "Supplier Name",
  //     dataIndex: "supplierName",
  //     render: (text, record) => (
  //       <span className="productimgname">
  //         <Link to="#" className="product-img stock-img">
  //           <ImageWithBasePath alt="" src={record.image} />
  //         </Link>
  //         <Link to="#">{text}</Link>
  //       </span>
  //     ),
  //     sorter: (a, b) => a.supplierName.length - b.supplierName.length,
  //   },
  //   {
  //     title: "Code",
  //     dataIndex: "code",
  //     sorter: (a, b) => a.code.length - b.code.length,
  //   },

  //   {
  //     title: "Email",
  //     dataIndex: "email",
  //     sorter: (a, b) => a.email.length - b.email.length,
  //   },

  //   {
  //     title: "Phone",
  //     dataIndex: "phone",
  //     sorter: (a, b) => a.phone.length - b.phone.length,
  //   },

  //   {
  //     title: "Country",
  //     dataIndex: "country",
  //     sorter: (a, b) => a.country.length - b.country.length,
  //   },

  //   {
  //     title: "Action",
  //     dataIndex: "action",
  //     render: () => (
  //       <div className="action-table-data">
  //         <div className="edit-delete-action">
  //           <div className="input-block add-lists"></div>

  //           <Link className="me-2 p-2" to="#">
  //             <Eye className="feather-view" />
  //           </Link>

  //           <Link
  //             className="me-2 p-2"
  //             to="#"
  //             data-bs-toggle="modal"
  //             data-bs-target="#edit-units"
  //           >
  //             <Edit className="feather-edit" />
  //           </Link>

  //           <Link
  //             className="confirm-text p-2"
  //             to="#"
  //             onClick={showConfirmationAlert}
  //           >
  //             <Trash2 className="feather-trash-2" />
  //           </Link>
  //         </div>
  //       </div>
  //     ),
  //     sorter: (a, b) => a.createdby.length - b.createdby.length,
  //   },
  // ];

  const columns = useMemo(() => [

    {
      header: "client Name",
      accessorKey: "clientName",
      // size: 120,
          },
    {
      header: "UnitName",
      accessorKey: "unitName",
      // Cell: ({ row }) =>
      //   moment(row.original.CreatedDate).format("MM/DD/YYYY h:mm A"),
    },
    {
      header: "Unit Location",
      accessorKey: "unitLocation",
      // Cell: ({ row }) =>
      //   moment(row.original.CreatedDate).format("MM/DD/YYYY h:mm A"),
    },
  ]);
  const renderRowActionMenuItems = ({ row }) => [
    (
      <MenuItem
        key="edit"
        onClick={() => Navigate(`/ManageClient/${row.original.ID}`)}
      >
        Edit
      </MenuItem>
    ) ,
//  (
//       <MenuItem
//         className="confirm-text"
//         to="#"
//         // key="delete"

//         title="Delete"
//         data-bs-toggle="modal"
//         data-bs-target="#DeleteConfirmationModal"
//         onClick={() =>
//           handleDeletePopup(
//             row.original.SaleTypeId,
//             row.original.ID,
//             row.original.QuickBookId,
//             "",
//             "singlerowdelete"
//           )
//         }
//       >
//         Delete
//       </MenuItem>
//     ),
  ];
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  // const renderCollapseTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Collapse
  //   </Tooltip>
  // );
  // const MySwal = withReactContent(Swal);

  // const showConfirmationAlert = () => {
  //   MySwal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     showCancelButton: true,
  //     confirmButtonColor: "#00ff00",
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonColor: "#ff0000",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       MySwal.fire({
  //         title: "Deleted!",
  //         text: "Your file has been deleted.",
  //         className: "btn btn-success",
  //         confirmButtonText: "OK",
  //         customClass: {
  //           confirmButton: "btn btn-success",
  //         },
  //       });
  //     } else {
  //       MySwal.close();
  //     }
  //   });
  // };
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Client</h4>
              <h6>Manage your Client</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <Link to={route.manageclient} className="btn btn-added">
              <PlusCircle className="me-2" />
              Add New Client
            </Link>
          </div>
        </div>
      </div>
      <div className="content">
        <Breadcrumbs
          maintitle="Supplier List "
          subtitle="Manage Your Supplier"
          addButton="Add New Supplier"
        />
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <Link
                  className={`btn btn-filter ${
                    isFilterVisible ? "setclose" : ""
                  }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
              <div className="form-sort stylewidth">
                <Sliders className="info-img" />

                <Select
                  classNamePrefix="react-select"
                  className="img-select"
                  options={options}
                  placeholder="Sort by Date"
                />
              </div>
            </div>
            {/* /Filter */}
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <User className="info-img" />
                      <Select
                        classNamePrefix="react-select"
                        className="img-select"
                        options={optionsTwo}
                        placeholder="Choose Customer Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <Globe className="info-img" />
                      <Select
                        classNamePrefix="react-select"
                        className="img-select"
                        options={countries}
                        placeholder="Choose Country"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                    <div className="input-blocks">
                      <a className="btn btn-filters ms-auto">
                        {" "}
                        <i
                          data-feather="search"
                          className="feather-search"
                        />{" "}
                        Search{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Filter */}
            <div className="table-responsive">
              {/* <Table
                className="table datanew"
                columns={columns}
                dataSource={data}
                rowKey={(record) => record.id}
              /> */}
              {/* <CommonMatrialReactTable1 columns={columns} data={data}/>  */}
            
            <CommonMatrialReactTable columns={columns} data={data} renderRowActionMenuItems={renderRowActionMenuItems}   enableRowActions/>
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>

      <SupplierModal />
    </div>
  );
};

export default Client;
